module.exports = __webpack_public_path__ + "static/media/48.45d882b0.jpg";